module.exports = __webpack_public_path__ + "img/project_3_8.7ade9798.jpg";